export default __webpack_public_path__ + "static/media/ISFJ-1.d9514e05.png";